module.exports = __webpack_public_path__ + "static/media/indonesia.ab580884.png";